module.exports = __webpack_public_path__ + "static/media/algae3.07a4287f.svg";